import React, {Fragment} from "react";
import {Garage, PartnerConfig} from "@App/types";
import {Text} from "@eo-locale/react";

type GarageProfileFooterProps = {
    garages: Garage[],
    current: Garage,
    partner: PartnerConfig
};


export const GarageProfileFooter = React.memo<GarageProfileFooterProps>(({
                                                                             garages, current, partner
                                                                         }: GarageProfileFooterProps) => {

    return (
        <>
            <aside className={'lg:max-w-[928px] lx:max-w-screen-lgplus my-0 mx-6 md:mx-12 lg:mx-auto'}>

                {(garages.length > 1 && partner.shouldDisplayNearby) && (
                    <>
                        <div className={'text-xl font-serif leading-8 font-semibold text-gray-500 pb-6'}>Werkstätten
                            in der Nähe
                        </div>
                        <div className={'col-span-12 grid grid-cols-2 gap-3 mb-8'}>
                            {garages.map((garage: Garage) => {
                                    return (
                                        <span className={'block'} key={garage.id}>
                                        <a href={`${process.env.NEXT_PUBLIC_BASE_URL}werkstatt/${garage.profileSlug?.split('/')[0]}/${garage.id}-${garage.profileSlug?.split('/')[1]}/`}
                                           target={'_blank'} rel={'noreferrer'}
                                           className={'text-sm text-gray-500 font-normal no-underline'}>{garage.name}</a>
                                    </span>
                                    );
                                }
                            )}
                        </div>
                    </>
                    )}
                <div
                    className="breadcrumbs col-span-full mb-4 grid md:flex justify-start gap-4 items-center text-gray-500">
                    <a href={`${process.env.NEXT_PUBLIC_BASE_URL}`} className={'flex items-center no-underline'}>
                        <i className={'fa-kit fa-home fa-fw text-gray-700 text-regular inline-block cursor-pointer mr-2'}/>
                        <i className={'fa-kit fa-chevron-right fa-fw text-gray-700 text-regular inline-block ml-2 mr-2'}/>
                    </a>

                    <a href={`https://www.repareo.de/werkstatt-in-deiner-naehe/`} className={'flex text-gray-500 no-underline font-normal items-center'}>
                        <Text id={'garage_nearby'}/>
                        <i className={'fa-kit fa-chevron-right fa-fw text-gray-700 text-regular inline-block ml-2 mr-2'}/>
                    </a>

                    {current.baseCity.published_at && (
                        <>
                            <a href={`${process.env.NEXT_PUBLIC_BASE_URL}werkstatt/${current.baseCity.slug}/`}
                            className={'flex text-gray-500 no-underline font-normal items-center'}>
                            <Text id={'garages_in_breadcrumb'} location={`${current.baseCity.name}`} html={true} tagName={'span'}/>
                                <i className={'fa-kit fa-chevron-right fa-fw text-gray-700 text-regular inline-block ml-2 mr-2'}/>
                            </a>
                        </>
                    )}

                    <Fragment>
                        {current.name}
                    </Fragment>
                </div>
            </aside>

                    <footer className={'garageProfile__footer bg-gray-100 border-t-gray-200 pt-6 mt-10 pb-28 md:pb-10'}>
                    <div className="lg:max-w-[928px] lx:max-w-screen-lgplus my-0 mx-6 md:mx-12 lg:mx-auto">
                        <div className={'col-span-full'}>
                                <div className="col-span-12 flex flex-col md:flex-row justify-center gap-x-5 text-sm mb-3">
                                    <a href={'https://www.repareo.de/ueber-uns-repareo/'} target={'_blank'} rel={'noreferrer'}
                                       title={'Über uns'}
                                       className={'leading-6 font-normal text-gray-500  decoration-0 no-underline col-span-6 md:col-span-4 xl:col-span-3 mb-3'}>Über
                                        uns</a>
                                    <a href={'https://lp.repareo.de/ws/registrierung-ihrer-werkstatt'} target={'_blank'}
                                       rel={'noreferrer'} title={'Werkstattpartner werden'}
                                       className={'leading-6 font-normal text-gray-500  decoration-0 no-underline col-span-6 md:col-span-4 xl:col-span-3 mb-3'}>Werkstatt&shy;partner
                                        werden</a>
                                    <a href={'https://www.repareo.de/datenschutzerklaerung/'} target={'_blank'}
                                       rel={'noreferrer'} title={'Datenschutzerklärung'}
                                       className={'leading-6 font-normal text-gray-500  decoration-0 no-underline col-span-6 md:col-span-4 xl:col-span-3 mb-3'}>Datenschutz&shy;erklärung</a>
                                    <a href={'https://www.repareo.de/impressum/'} target={'_blank'} rel={'noreferrer'}
                                       title={'Impressum'}
                                       className={'leading-6 font-normal text-gray-500  decoration-0 no-underline col-span-6 md:col-span-4 xl:col-span-3 mb-3'}>Impressum</a>
                                    <a href={'https://www.repareo.de/haftungsausschluss/'} target={'_blank'}
                                       rel={'noreferrer'} title={'Haftungsausschluss'}
                                       className={'leading-6 font-normal text-gray-500  decoration-0 no-underline col-span-6 md:col-span-4 xl:col-span-3 mb-3'}>Haftungs&shy;auschluss</a>
                                    <a href={'https://www.repareo.de/hauptuntersuchung-hu-au/'} target={'_blank'}
                                       rel={'noreferrer'} title={'TÜV'}
                                       className={'leading-6 font-normal text-gray-500  decoration-0 no-underline col-span-6 md:col-span-4 xl:col-span-3 mb-3'}>TÜV</a>
                                    <a href={'https://www.repareo.de/ueberblick-repareo-themenlandschaft/'}
                                       target={'_blank'} rel={'noreferrer'} title={'Themenangebot'}
                                       className={'leading-6 font-normal text-gray-500  decoration-0 no-underline col-span-6 md:col-span-4 xl:col-span-3 mb-3'}>Themen&shy;angebot</a>
                                </div>
                                <span
                                    className={'col-span-12 flex justify-center text-base leading-6 font-normal text-gray-400'}>© {(new Date()).getFullYear()} repareo GmbH</span>
                        </div>
                    </div>

                </footer>
        </>
    );
})

GarageProfileFooter.displayName = 'GarageProfileFooter';
